import React from 'react';
import HowItWorks from './HowItWorksSection';
import About from './AboutSection';
import Service from './ServiceSection';
import HomeSlider from './SliderSection';
import Campus from './CampusSection';
import ScrollToTop from '../../components/ScrollTop';

const HomeMain =() => {
		return (
			<>
				<div className="react-wrapper">
            		<div className="react-wrapper-inner">
						{/* SliderSection-start */}
						<HomeSlider />
						{/* SliderSection-start */}

						{/* About-area-start */}
						<About />
						{/* About-area-end */}

						{/* Service-area-start */}
						<Service />
						{/* Service-area-end */}

					{/* How It Works-area-start */}
					<HowItWorks />
					{/* How It Works-area-end */}

					{/* Campus-area-start */}
					<Campus />
					{/* Campus-area-end */}



					{/* scrolltop-start */}
					<ScrollToTop
						scrollClassName="home react__up___scroll"
					/>
					{/* scrolltop-end */}
					</div>
				</div>

			</>
		);
	}

export default HomeMain;